import { IsoLanguagesRegions } from "../enums/locale.js";
var DEFAULT_ISO_LANGUAGE_REGION = IsoLanguagesRegions.EN;
export { DEFAULT_ISO_LANGUAGE_REGION };